import { cn } from 'lib/utils'
import { ComponentPropsWithoutRef, forwardRef } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import { layoutRecipeClassnames } from './layout-classnames'

const paneRecipe = tv({
  base: 'grow-0 shrink-0',
  variants: {
    stretch: {
      true: 'grow shrink overflow-auto',
    },
    scrollable: {
      true: 'overflow-auto',
    },
    withDots: {
      true: 'bg-secondary/50 bg-[radial-gradient(var(--border)_1px,transparent_1px)] bg-position-[0.1rem_0.15rem] bg-size-[0.75rem_0.75rem]',
    },
  },
})

type PaneVariants = VariantProps<typeof paneRecipe>

export const HBox = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({ className, ...props }, ref) => (
  <div className={cn(layoutRecipeClassnames.hbox, className)} {...props} ref={ref} />
))

export const VBox = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({ className, ...props }, ref) => (
  <div className={cn(layoutRecipeClassnames.vbox, className)} {...props} ref={ref} />
))

export type PaneProps = ComponentPropsWithoutRef<'div'> & PaneVariants

export const Pane = forwardRef<HTMLDivElement, PaneProps>(
  ({ className, stretch, scrollable, withDots, ...props }, ref) => {
    const classes = paneRecipe({ stretch, scrollable, withDots })

    return <div ref={ref} className={cn(layoutRecipeClassnames.pane, classes, className)} {...props} />
  },
)
